import { selectDialog } from "../redux/dialogSlice";
import { useAppSelector } from "@app/hooks/useAppDispatch";

export const AppDialogs = () => {
  const { items: dialogItems } = useAppSelector(selectDialog);

  return (
    <>
      {dialogItems.map(({ id, comp: Comp, props }) => (
        <Comp key={id} {...props} />
      ))}
    </>
  );
};
